import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import NavBarNew from "./navBar";
import SEO from "../SEO/seo";

function SoftwareServices() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  const scaleFade = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  const imageZoom = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
  };

  const slideLeftToRight = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRightT0Left = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };
  return (
    <>
      <SEO
        title="Software Services | Kryzen Alpha Farm Management Platform"
        description="Kryzen Alpha is an exclusive platform for KBPL clients — India's fastest-growing commercial hydroponic farm management system for streamlined operations and growth."
        keywords="hydroponic software, farm management platform, kryzen alpha, commercial hydroponic farming India, kbpl client software, agriculture SaaS, hydroponic tech solutions, smart farming software"
        canonical="https://alpha.kryzen.com/why-kryzen-biotech"
        ogTitle="Why Kryzen Biotech? | Hydroponic Farm Development Experts"
        ogDescription="Kryzen Biotech delivers end-to-end hydroponic farming solutions with custom nutrients, high-tech systems, and full lifecycle support — trusted by commercial growers across India."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752470324/tech_first_pb5vk2.png"
        twitterTitle="Software Services | Kryzen Alpha Farm Management Platform"
        twitterDescription="Kryzen Alpha is a hydroponic farm management platform exclusively for KBPL clients — built to simplify and scale commercial agriculture operations in India."
      />
      <div>
        <Slider
          heding={"kryzen software services"}
          paragraph={
            "Kryzen Software Services offers tailored digital solutions to empower businesses in agriculture and beyond. From custom software development to automation, CRM, analytics, and web platforms — we build tech that simplifies operations, improves productivity, and supports growth."
          }
        ></Slider>
        <div className="container mainDiv py-5">
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
            >
              kryzen software services
            </motion.h1>
            <span className="text-uppercase fs-2">
              <b>Develop Beautiful Farms With Kryzen</b>
            </span>
            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-2"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              Kryzen Alpha is exclusive kbpl client only platform.
              <br></br>
              Welcome to India's fastest growing commercial hydroponic farm
              management system
            </motion.p>
          </div>
          <div className="row g-5 align-items-stretch">
            {/* Left Column */}
            <div className="col-md-12">
              <motion.div
                className="border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={fadeUp}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467033/301_vlb1xp.png"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid"
                  style={{ width: "100%" }}
                />
              </motion.div>
            </div>
          </div>
          <div className="row g-5 align-items-stretch mt-2">
            {/* Left Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/cropScheduler_ad6e6h.png"
                    alt="CROP Scheduler"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Crop Scheduler
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/agronomywiki_ciaz1q.png"
                    alt="Agronomy Wikipedia"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Agronomy Wikipedia
                  </h5>
                </div>
              </div>
            </div>
            {/* Right Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/expenseTracker_tceteg.png"
                    alt="Expense Tracker"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Expense Tracker
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/assetPlanning_rsnnsd.png"
                    alt="Expense Tracker"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Asset Planning
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-5 align-items-stretch mt-2">
            {/* Left Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/inventory_vgkiax.png"
                    alt="CROP Scheduler"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Inventory & Stocking
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467868/pricewatcher_l2jhj8.png"
                    alt="Price Watcher"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Price Watcher
                  </h5>
                </div>
              </div>
            </div>
            {/* Right Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467868/stafPayrll_khkfvo.png"
                    alt="Staff & Payroll"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Staff & Payroll
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/farmSupport_kosorf.png"
                    alt="Expense Tracker"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Farm Support
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-5 align-items-stretch mt-2">
            {/* Left Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/clientPlanning_i5rbqw.png"
                    alt="Client Planning"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Client Planning
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467868/seedsPurches_chwg8j.png"
                    alt="Seeds Purchase"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Seeds Purchase
                  </h5>
                </div>
              </div>
            </div>
            {/* Right Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467868/nutrientFoormula_f0dgft.png"
                    alt="Nutrient Formula"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Nutrient Formula
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <motion.img
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={imageZoom}
                    transition={{ duration: 0.6 }}
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/buyersConnect_zcvh2x.png"
                    alt="Buyers Connect"
                    className="card-img-top img-fluid"
                    style={{ width: "100%" }}
                  />
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Buyers Connect
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase mt-7"
            >
              What you experience inside?
            </motion.h1>

            <hr></hr>
          </div>
          <div className="row g-5 align-items-stretch">
            {/* Left Column */}
            <div className="col-md-6">
              <motion.div
                className="card border-0 h-100 p-3"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideLeftToRight}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752469258/kryzen-nursary-management_hzxqiz_a20j63_oqjy33.png"
                  alt="Manage Your Farm"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "350px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Manage Your Farm
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    From batch planning to nursery management, alpha helps you
                    manage your day to day farm activity very effectivly.
                  </motion.p>
                </div>
              </motion.div>
            </div>
            {/* Right Column */}
            <div className="col-md-6">
              <motion.div
                className="card border-0 h-100 p-3"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideRightT0Left}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752469258/kryzen-nursary-planning_yggakg_ic3wlm_l7pv7r.png"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "350px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Manage Your Nursary
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Don't just sow seeds, track there schedule and be on top of
                    the progress. Nursery planner gives you complete schedule.
                  </motion.p>
                </div>
              </motion.div>
            </div>
            <div className="col-md-6">
              <motion.div
                className="card border-0 h-100 p-3"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideRightT0Left}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752469258/hydroponic-nutrient-system_bxh8ho_ouuyio_soqmup.png"
                  alt="Accurate Nutrient Calculation"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "350px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Accurate Nutrient Calculation
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Don't overdo it or underdo it. Hydroponic nutrint calculator
                    will help you identify exact nutrients your farm need.
                  </motion.p>
                </div>
              </motion.div>
            </div>
            <div className="col-md-6">
              <motion.div
                className="card border-0 h-100 p-3"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideRightT0Left}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752469258/hydroponic-water-qwality_x0mz7e_effmnm_qf7kj7.png"
                  alt="Manage Your Nursary"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "350px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Track Farm Water
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Let it be nutrients or PH of water. Tracking the changes
                    from source to what is available to plants made easy with
                    water tracking system.
                  </motion.p>
                </div>
              </motion.div>
            </div>
            <div className="text-center py-2 ">
              <motion.h1
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={fadeUp}
                transition={{ duration: 0.7 }}
                className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase mt-7"
              >
                Why Optin for Alpha?
              </motion.h1>

              <hr></hr>
            </div>
            <div className="row align-items-stretch mt-2">
              <div className="col-md-3 p-5">
                <div
                  className=" border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                  style={{
                    background:
                      "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                    color: "black",
                    border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                    padding: "1rem",
                    borderRadius: "0.25rem",
                  }}
                >
                  <div className="card-body p-4 text-center">
                    <motion.img
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: false, amount: 0.3 }}
                      variants={imageZoom}
                      transition={{ duration: 0.6 }}
                      src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752470324/tech_first_pb5vk2.png"
                      alt="We are Tech First"
                      className="card-img-top img-fluid"
                      style={{ width: "100%" }}
                    />
                    <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                      We are Tech First
                    </h5>
                    <p>
                      We are seamlessly blending technology and farming
                      together. Making it easy for modern age adoption.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-3 p-5">
                <div
                  className=" border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                  style={{
                    background:
                      "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                    color: "black",
                    border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                    padding: "1rem",
                    borderRadius: "0.25rem",
                  }}
                >
                  <div className="card-body p-4 text-center">
                    <motion.img
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: false, amount: 0.3 }}
                      variants={imageZoom}
                      transition={{ duration: 0.6 }}
                      src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752470324/farmers_first_abuuny.png"
                      alt="We are Farmers First"
                      className="card-img-top img-fluid"
                      style={{ width: "100%" }}
                    />
                    <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                      We are Farmers First
                    </h5>
                    <p>
                      All things we build are from our own experience and
                      requirements. No useless stuff; things that we use
                      ourselves.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-3 p-5">
                <div
                  className=" border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                  style={{
                    background:
                      "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                    color: "black",
                    border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                    padding: "1rem",
                    borderRadius: "0.25rem",
                  }}
                >
                  <div className="card-body p-4 text-center">
                    <motion.img
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: false, amount: 0.3 }}
                      variants={imageZoom}
                      transition={{ duration: 0.6 }}
                      src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752470324/community_first_ftzy7w.png"
                      alt="We are Community First"
                      className="card-img-top img-fluid"
                      style={{ width: "100%" }}
                    />
                    <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                      We are Community First
                    </h5>
                    <p>
                      We are a group of people reshaping modern agriculture. And
                      everyone (including you) is part of the community we have
                      built.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-3 p-5">
                <div
                  className=" border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                  style={{
                    background:
                      "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                    color: "black",
                    border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                    padding: "1rem",
                    borderRadius: "0.25rem",
                  }}
                >
                  <div className="card-body p-4 text-center">
                    <motion.img
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: false, amount: 0.3 }}
                      variants={imageZoom}
                      transition={{ duration: 0.6 }}
                      src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/agronomywiki_ciaz1q.png"
                      alt="Buyers Connect"
                      className="card-img-top img-fluid"
                      style={{ width: "100%" }}
                    />
                    <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                      We are Innovators First
                    </h5>
                    <p>
                      We build things not only for today but for tomorrow as
                      well. Innovation is at the core of Kryzen and everything
                      we build in it.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr></hr>
          {/* <h1 className="display-6 fw-bold text-uppercase text-center mb-2 mt-7">
            Our Core Values That Make Us #1 Hydroponics Company of India
          </h1>
          <hr></hr>{" "} */}
          <div className="row g-5 align-items-stretch mt-2">
            {/* Left Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Climate Management
                  </h5>
                  <p style={{ fontSize: "18px" }}>
                    IoT based micro climate analysis and auto management system
                    makes it easier to grow any plant anywhere with Kryzen farm
                    maangement system.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className="border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Fertigation Management
                  </h5>
                  <p style={{ fontSize: "18px" }}>
                    With precise pH & EC calculation in realtime integration of
                    hydroBUILD & Alpha makes nutrient or fertigation management
                    seamlessly easy.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Agronomy Management
                  </h5>
                  <p style={{ fontSize: "18px" }}>
                    Not just plant wikipedia but stay connected with agronomist
                    all the time, grow what you love and always have dedicated
                    support from the expert of the domain.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className="border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h3 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Everything Secure
                  </h3>
                  <p style={{ fontSize: "18px" }}>
                    All your data and plans, secure with us. We use state of the
                    art encryption and data management services. So all your
                    research and project data is always safe with us.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
}

export default SoftwareServices;
